'use strict'

// this stuff is not taken from rootGetters['situation/api/responseAPI']
// import Api from '@/api/response.js'
// --

import { setResponseComputedName } from '@/_helpers/utils.js'

const state = {
  loading: false,
  error: null,
  responses: [],
  filters: {
    status: null,
    vacancy: null,
    stage: null,
    page: 1,
    count: 40
  },
  sorting: {
    name: null,
    order: 'asc'
  },
  pagination: {
    pageNumber: 1,
    totalPages: 1,
    totalCounts: 0,
    count: 5,
    load_more_pages: 1,
    is_load_more: false
  }
}

const actions = {
  fetch ({ commit, state, rootGetters }, { searchTerm }) {
    commit('fetch')

    const filters = state.filters
    const sorting = state.sorting
    const params = {
      search_term: searchTerm
    }

    Object.keys(filters)
      .filter(key => !filters[key] || !filters[key].id || (filters[key].id !== 'all')) // check if no id or id is not 'all'
      .forEach(key => {
        if (filters[key] && filters[key].id) {
          Object.assign(params, {
            [ `${key}_id` ]: filters[key].id
          })
        } else {
          Object.assign(params, {
            [ key ]: filters[key]
          })
        }
      })

    if (sorting.name) {
      Object.assign(params, {
        sort_by: sorting.name,
        sort_order: sorting.order
      })
    }

    let count = state.pagination.count;

    const is_load_more = state.pagination.is_load_more;

    if (is_load_more) {
      count = (state.pagination.pageNumber * state.responses.length) + state.pagination.count

      params.page = 1;
      params.count = count
    } else {
      params.page = state.pagination.pageNumber
      params.count = state.pagination.count
    }

    return rootGetters['situation/api/responseAPI'].fetch(params)
      .then(({data, meta}) => {
        commit('fetchSuccess', {data, meta, is_load_more})

        if (is_load_more) {
          commit('set_pagination_more', {count})
        }
      })
      .catch(err => commit('fetchFailure', err))
  },

  updateFilters ({commit, state, dispatch}, data) {
    const vacancy = data.data && data.data.vacancy ? data.data.vacancy : null
    // if selected filter is vacancy, determine active process depends on vacancy
    if (vacancy) {
      const activeProcessName = vacancy.meta && vacancy.meta.active_process
        ? vacancy.meta.active_process
        : null

      dispatch('process/setName', activeProcessName, {root: true})
    }
    // --

    commit('resetPagination')
    commit('updateFilters', data)

    dispatch('fetch')
  },

  updateSorting ({ commit, state, dispatch }, data) {
    commit('updateSorting', data)
    dispatch('fetch')
  }

  // xlsExport ({ commit, state, dispatch, rootGetters }, ids) {
  //   commit('xlsExporting', true)
  //   const params = {
  //     page: 1,
  //     count: 100,
  //     ids: ids
  //   }
  //   if (state.filters.vacancy && state.filters.vacancy.id !== 'all') {
  //     params.vacancy_id = state.filters.vacancy.id
  //   }
  //   if (state.filters.status) {
  //     params.status_id = state.filters.status.id
  //   }
  //   rootGetters['situation/api/responseAPI'].xlsExport(params)
  //     .then((data) => {
  //       commit('xlsExporting', false)
  //       window.location = data.data[0].url
  //     })
  //     .catch(err => {
  //       commit('xlsExporting', false)
  //       dispatch('global/setError', err, { root: true })
  //     })
  // }
}

const mutations = {
  fetch (state) {
    state.loading = true
  },

  fetchSuccess (state, {data, meta, is_load_more}) {
    if (!is_load_more) {
      state.pagination.totalPages = Math.ceil(meta.total / state.pagination.count)
    }

    state.pagination.totalCounts = meta.total
    state.responses = data.map(response => setResponseComputedName(response))
    state.loading = false
  },

  fetchFailure (state, err) {
    state.error = err
    state.loading = false
    console.error(err)
  },

  updateFilters (state, { data }) {
    Object.assign(state.filters, data)
  },

  updateSorting (state, data) {
    Object.assign(state.sorting, data)
  },

  updatePagination (state, params) {
    state.pagination = Object.assign(state.pagination, params)
  },

  resetPagination (state) {
    state.pagination = Object.assign({}, state.pagination, {
      pageNumber: 1,
      totalPages: 1,
      totalCounts: 0,
      count: 5,
      load_more_pages: 1,
      is_load_more: false
    })
  },

  set_load_more (state, val) {
    state.pagination = Object.assign(state.pagination, {
      is_load_more: val
    })
  },

  set_pagination_more (state, {count}) {
    state.pagination.load_more_pages = Math.ceil(count / state.pagination.count)
  },

  change_count (state, val) {
    state.pagination = Object.assign(state.pagination, {
      count: val,
      pageNumber: 1
    })
  },

  clear() {
    state.responses = [];

    state.pagination = Object.assign({}, state.pagination, {
      pageNumber: 1,
      totalPages: 1,
      totalCounts: 0,
      count: 5,
      load_more_pages: 1,
      is_load_more: false
    })
  }
}

const getters = {
  error: state => {
    return state.error;
  },

  sorting: state => {
    return state.sorting;
  },

  filters: state => {
    return state.filters;
  },

  pagination: state => {
    return state.pagination;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
